export enum RequestStatus {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}
